import { z } from "zod";
import { AdminListInputSchema, adminListOutput } from "./common";

// =============
// Admin Purchase Event Schemas
// =============

/**
 * Processing status enum.
 */
export const PurchaseEventProcessingStatusSchema = z.enum([
	"pending",
	"processed",
	"failed",
	"skipped",
]);
export type PurchaseEventProcessingStatus = z.infer<
	typeof PurchaseEventProcessingStatusSchema
>;

/**
 * Admin purchase event schema.
 */
export const AdminPurchaseEventSchema = z.object({
	id: z.string(),
	appId: z.string(),
	installId: z.string(),
	transactionId: z.string(),
	eventType: z.string(),
	eventTime: z.coerce.date(),
	amountCents: z.number().int(),
	currency: z.string(),
	amountCentsUSD: z.number().int(),
	exchangeRate: z.string(),
	exchangeRateDate: z.string(),
	exchangeRateSource: z.string(),
	processingStatus: PurchaseEventProcessingStatusSchema,
	needsReview: z.boolean(),
	raw: z.string().nullable(),
});
export type AdminPurchaseEvent = z.infer<typeof AdminPurchaseEventSchema>;

/**
 * Admin purchase event list input with filters.
 */
export const AdminPurchaseEventListInputSchema = AdminListInputSchema.extend({
	filter: z
		.object({
			appId: z.string().optional(),
			installId: z.string().optional(),
			transactionId: z.string().optional(),
			eventType: z.string().optional(),
			processingStatus: PurchaseEventProcessingStatusSchema.optional(),
			needsReview: z.coerce.boolean().optional(),
			eventTimeAfter: z.coerce.date().optional(),
			eventTimeBefore: z.coerce.date().optional(),
		})
		.optional(),
});
export type AdminPurchaseEventListInput = z.infer<
	typeof AdminPurchaseEventListInputSchema
>;

/**
 * Admin purchase event list output.
 */
export const AdminPurchaseEventListOutputSchema = adminListOutput(
	AdminPurchaseEventSchema,
);
export type AdminPurchaseEventListOutput = z.infer<
	typeof AdminPurchaseEventListOutputSchema
>;
